<template lang="html">
	<div id="app">
    <div  class="bg-white">
	<router-view :key="this.$store.state.sidebar.navigationClicked"></router-view>
    </div>
	<div class="app-loading-overlay" v-if="showloading">
		<LoadingSpinner />
	</div>
	</div>
</template>

<script lang="js">
import LoadingSpinner from "@/components/LoadingSpinner.vue";
	export default {
		name: 'appoliver',
		components: {
			LoadingSpinner
		},
        data() {
            return {
              showloading: false
            };
        },
        created(){
            if(this.$route.path.includes("/mycalendar") || this.$route.path.includes("/client-service-proposal")) {
                this.showloading = false;
            }
        },
        watch: {
            $route(to, from) {
                if (from && from.path.includes("/login") && !to.path.includes("/login")) {
                    this.showloading = true;
                    setTimeout(() => { this.showloading = false; }, 1200);
                }
            }
        }
	}

</script>
<style scoped>
/* Overlay a pantalla completa: centrado encima de todo, no debajo del footer */
.app-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.92);
}

/* .fadeinoliver small {
	z-index:-3;
    top:40%;
    margin-top:95px;
    width:100%;
    text-align:center;
    position:absolute;
}
.fadeinoliver img {
	width:90px;
    left: 50%;
	z-index:-999;
    top:40%;
    margin-left: -45px !important;
    position:absolute;
    -webkit-animation-name: fade;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 6s;
    animation-name: fade;
    animation-iteration-count: infinite;
    animation-duration: 6s;
} */

@-webkit-keyframes fade {
    0% {opacity: 0;}
    20% {opacity: 1;}
    33% {opacity: 1;}
    53% {opacity: 0;}
    100% {opacity: 0;}
}
@keyframes fade {
    0% {opacity: 0;}
    20% {opacity: 1;}
    33% {opacity: 1;}
    53% {opacity: 0;}
    100% {opacity: 0;}
}

#f1 {
}
#f2 {
    -webkit-animation-delay: -2s;
}
#f3 {
    -webkit-animation-delay: -4s;
}

</style>
<style>
.convai-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

elevenlabs-convai {
  display: block;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  min-height: 560px; /* asegura que el panel tenga alto */
}
</style>